<template>
  <fade-shift ratio="0.9">
    <section
      :class="{
        'text-blue text-lg py-10 px-4 md:px-10 font-sans': true,
        'no-icon': noIcon,
      }"
    >
      <div
        v-if="!noIcon"
        class="icon-container relative flex items-center justify-center"
      >
        <img
          src="../assets/images/water_colour_circle.png"
          role="presentation"
          class="icon-background"
          v-if="!noBackground"
        />
        <img
          :src="options[fact]"
          role="presentation"
          class="icon-image absolute"
        />
      </div>
      <p
        v-html="$t(`i18nSections.atAGlance.byTheNumbers.${fact}`)"
        class="block"
      />
    </section>
  </fade-shift>
</template>

<script>
export default {
  name: "ByTheNumbers",
  components: {
    fadeShift: () => import("@/components/FadeShift.vue"),
  },
  props: {
    fact: {
      type: String,
      required: true,
      validator: value => {
        const options = [
          "6000Canadians",
          "1000Farmers",
          "2InterParesCounterparts",
          "25000Women",
          "governmentFunding",
          "28Visits",
          "326Women158Men",
          "1Lawsuit",
          "50DevelopmentProjects",
        ];

        return options.includes(value);
      },
    },
    noIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    noBackground: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      options: {
        "6000Canadians": require("../assets/images/pen.svg"),
        "1000Farmers": require("../assets/images/enda-pronat.png"),
        "2InterParesCounterparts": require("../assets/images/equator_prize_logo-2015-en.png"),
        "25000Women": require("../assets/images/likhaan-l.png"),
        governmentFunding: require("../assets/images/Photos/Celebrating_our_donor_community/money.svg"),
        "28Visits": require("../assets/images/logo-xs.png"),
        "326Women158Men": require("../assets/images/empowered-hand.svg"),
        "1Lawsuit": require("../assets/images/hammer.svg"),
        "50DevelopmentProjects": require("../assets/images/Photos/Celebrating_our_donor_community/volunteers.svg"),
      },
    };
  },
};
</script>

<style lang="scss" scoped>
section {
  display: grid;
  grid-template-columns: 6rem auto;
  grid-template-rows: auto;
  gap: 0.5rem;

  &.no-icon {
    grid-template-columns: auto;
  }

  p {
    align-self: center;
  }
}

.icon-container {
  width: 5rem;
}
</style>
